import type { Palette } from '@mui/material'

/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
 * Generated from /networks/<<template_id>>/darkPalette.json
 */
const TEMPLATE_PALETTE = {} as Partial<Palette>
export default TEMPLATE_PALETTE
